import React from "react";
import { Link } from "react-router-dom";

interface MapProps {
    data: any;
    isLoading: boolean;
}

const Map: React.FC<MapProps> = (props) => {
    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <section id="map">
                        {/* marker description and marker icon goes here */}
                        <div className="map_marker_description">
                            <h3>{props.data?.title}</h3>
                            <p
                                dangerouslySetInnerHTML={{ __html: props.data?.content }}
                            ></p>
                            <iframe
                                width={"100%"}
                                height={500}
                                style={{ border: "1px solid #000", }}
                                src={props.data?.googlemapurl} />
                        </div>
                    </section>
                </div>
            </div>
            <div style={{ marginBottom: "200px" }}></div>
            <div className="row topmargin_40">
                <div className="col-sm-4">
                    <div className="teaser text-center">
                        <div className="teaser_icon highlight size_normal">
                            <i className="rt-icon2-phone5" />
                        </div>
                        <p>
                            <span className="grey">Tel:</span> {props.data?.tel1}
                            <br />
                            {props.data?.tel2 && (
                                <>
                                    <span>
                                        <span className="grey">Tel:</span> {props.data.tel2}
                                    </span>
                                    <br />
                                </>
                            )}
                            <span className="grey">Fax:</span> {props.data?.fax}
                        </p>
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="teaser text-center">
                        <div className="teaser_icon highlight size_normal">
                            <Link to={props.data?.google_map_url} target="_blank" rel="noopener noreferrer">
                                <i className="rt-icon2-location2" />
                            </Link>
                        </div>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: props.data?.adres
                            }}
                        ></p>
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="teaser text-center">
                        <div className="teaser_icon highlight size_normal">
                            <i className="rt-icon2-mail" />
                        </div>
                        <p>{props.data?.email}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Map;